/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateDocGenTaskReq,
  DocGenSectionResp,
  DocGenTaskDetailResp,
  DocGenTaskListItemResp,
  DocGenTaskLogResp,
  ListDocGenTasksParams,
  PinDocGenTaskBody,
  RewriteDocGenSectionReq,
  UpdateDocGenOutlineReq,
  UpdateDocGenSectionContentReq,
  UpdateDocGenSheetsDraftReq,
} from "./doc-gen-task-api.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const createDocGenTask = (
  createDocGenTaskReq?: CreateDocGenTaskReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    {
      url: `/intl/doc-generation/tasks`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDocGenTaskReq,
      signal,
    },
    options,
  );
};

export const getCreateDocGenTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDocGenTask>>,
    TError,
    { data?: CreateDocGenTaskReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDocGenTask>>,
  TError,
  { data?: CreateDocGenTaskReq },
  TContext
> => {
  const mutationKey = ["createDocGenTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDocGenTask>>,
    { data?: CreateDocGenTaskReq }
  > = (props) => {
    const { data } = props ?? {};

    return createDocGenTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDocGenTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDocGenTask>>
>;
export type CreateDocGenTaskMutationBody = CreateDocGenTaskReq | undefined;
export type CreateDocGenTaskMutationError = unknown;

export const useCreateDocGenTask = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDocGenTask>>,
      TError,
      { data?: CreateDocGenTaskReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDocGenTask>>,
  TError,
  { data?: CreateDocGenTaskReq },
  TContext
> => {
  return useMutation(getCreateDocGenTaskMutationOptions(options), queryClient);
};
export const listDocGenTasks = (
  params?: ListDocGenTasksParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskListItemResp[]>(
    { url: `/intl/doc-generation/tasks`, method: "GET", params, signal },
    options,
  );
};

export const getListDocGenTasksQueryKey = (params?: ListDocGenTasksParams) => {
  return [`/intl/doc-generation/tasks`, ...(params ? [params] : [])] as const;
};

export const getListDocGenTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocGenTasks>>,
  TError = unknown,
>(
  params?: ListDocGenTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTasks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDocGenTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocGenTasks>>> = ({
    signal,
  }) => listDocGenTasks(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDocGenTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDocGenTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocGenTasks>>
>;
export type ListDocGenTasksQueryError = unknown;

export function useListDocGenTasks<
  TData = Awaited<ReturnType<typeof listDocGenTasks>>,
  TError = unknown,
>(
  params: undefined | ListDocGenTasksParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocGenTasks>>,
          TError,
          Awaited<ReturnType<typeof listDocGenTasks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDocGenTasks<
  TData = Awaited<ReturnType<typeof listDocGenTasks>>,
  TError = unknown,
>(
  params?: ListDocGenTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocGenTasks>>,
          TError,
          Awaited<ReturnType<typeof listDocGenTasks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDocGenTasks<
  TData = Awaited<ReturnType<typeof listDocGenTasks>>,
  TError = unknown,
>(
  params?: ListDocGenTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTasks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListDocGenTasks<
  TData = Awaited<ReturnType<typeof listDocGenTasks>>,
  TError = unknown,
>(
  params?: ListDocGenTasksParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTasks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListDocGenTasksQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDocGenTask = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    { url: `/intl/doc-generation/tasks/${id}`, method: "GET", signal },
    options,
  );
};

export const getGetDocGenTaskQueryKey = (id: string) => {
  return [`/intl/doc-generation/tasks/${id}`] as const;
};

export const getGetDocGenTaskQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocGenTask>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocGenTask>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDocGenTaskQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocGenTask>>> = ({
    signal,
  }) => getDocGenTask(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocGenTask>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDocGenTaskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocGenTask>>
>;
export type GetDocGenTaskQueryError = unknown;

export function useGetDocGenTask<
  TData = Awaited<ReturnType<typeof getDocGenTask>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocGenTask>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocGenTask>>,
          TError,
          Awaited<ReturnType<typeof getDocGenTask>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocGenTask<
  TData = Awaited<ReturnType<typeof getDocGenTask>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocGenTask>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocGenTask>>,
          TError,
          Awaited<ReturnType<typeof getDocGenTask>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocGenTask<
  TData = Awaited<ReturnType<typeof getDocGenTask>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocGenTask>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDocGenTask<
  TData = Awaited<ReturnType<typeof getDocGenTask>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDocGenTask>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDocGenTaskQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const deleteDocGenTask = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/intl/doc-generation/tasks/${id}`, method: "DELETE", signal },
    options,
  );
};

export const getDeleteDocGenTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDocGenTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDocGenTask>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteDocGenTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDocGenTask>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDocGenTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDocGenTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDocGenTask>>
>;

export type DeleteDocGenTaskMutationError = unknown;

export const useDeleteDocGenTask = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDocGenTask>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDocGenTask>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteDocGenTaskMutationOptions(options), queryClient);
};
export const generateDocGenOutline = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    { url: `/intl/doc-generation/tasks/${id}/outline`, method: "POST", signal },
    options,
  );
};

export const getGenerateDocGenOutlineMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDocGenOutline>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDocGenOutline>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["generateDocGenOutline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDocGenOutline>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return generateDocGenOutline(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDocGenOutlineMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDocGenOutline>>
>;

export type GenerateDocGenOutlineMutationError = unknown;

export const useGenerateDocGenOutline = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateDocGenOutline>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateDocGenOutline>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getGenerateDocGenOutlineMutationOptions(options),
    queryClient,
  );
};
export const updateDocGenOutline = (
  id: string,
  updateDocGenOutlineReq?: UpdateDocGenOutlineReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/outline`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateDocGenOutlineReq,
      signal,
    },
    options,
  );
};

export const getUpdateDocGenOutlineMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDocGenOutline>>,
    TError,
    { id: string; data?: UpdateDocGenOutlineReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDocGenOutline>>,
  TError,
  { id: string; data?: UpdateDocGenOutlineReq },
  TContext
> => {
  const mutationKey = ["updateDocGenOutline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDocGenOutline>>,
    { id: string; data?: UpdateDocGenOutlineReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDocGenOutline(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDocGenOutlineMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDocGenOutline>>
>;
export type UpdateDocGenOutlineMutationBody =
  UpdateDocGenOutlineReq | undefined;
export type UpdateDocGenOutlineMutationError = unknown;

export const useUpdateDocGenOutline = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDocGenOutline>>,
      TError,
      { id: string; data?: UpdateDocGenOutlineReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDocGenOutline>>,
  TError,
  { id: string; data?: UpdateDocGenOutlineReq },
  TContext
> => {
  return useMutation(
    getUpdateDocGenOutlineMutationOptions(options),
    queryClient,
  );
};
export const updateDocGenSheetsDraft = (
  id: string,
  updateDocGenSheetsDraftReq?: UpdateDocGenSheetsDraftReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/sheets-draft`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateDocGenSheetsDraftReq,
      signal,
    },
    options,
  );
};

export const getUpdateDocGenSheetsDraftMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDocGenSheetsDraft>>,
    TError,
    { id: string; data?: UpdateDocGenSheetsDraftReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDocGenSheetsDraft>>,
  TError,
  { id: string; data?: UpdateDocGenSheetsDraftReq },
  TContext
> => {
  const mutationKey = ["updateDocGenSheetsDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDocGenSheetsDraft>>,
    { id: string; data?: UpdateDocGenSheetsDraftReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateDocGenSheetsDraft(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDocGenSheetsDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDocGenSheetsDraft>>
>;
export type UpdateDocGenSheetsDraftMutationBody =
  UpdateDocGenSheetsDraftReq | undefined;
export type UpdateDocGenSheetsDraftMutationError = unknown;

export const useUpdateDocGenSheetsDraft = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDocGenSheetsDraft>>,
      TError,
      { id: string; data?: UpdateDocGenSheetsDraftReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDocGenSheetsDraft>>,
  TError,
  { id: string; data?: UpdateDocGenSheetsDraftReq },
  TContext
> => {
  return useMutation(
    getUpdateDocGenSheetsDraftMutationOptions(options),
    queryClient,
  );
};
export const confirmDocGenOutline = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/outline/confirm`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getConfirmDocGenOutlineMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmDocGenOutline>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmDocGenOutline>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["confirmDocGenOutline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmDocGenOutline>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return confirmDocGenOutline(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmDocGenOutlineMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmDocGenOutline>>
>;

export type ConfirmDocGenOutlineMutationError = unknown;

export const useConfirmDocGenOutline = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmDocGenOutline>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmDocGenOutline>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getConfirmDocGenOutlineMutationOptions(options),
    queryClient,
  );
};
export const rewriteDocGenSection = (
  id: string,
  sectionKey: string,
  rewriteDocGenSectionReq?: RewriteDocGenSectionReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenSectionResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/sections/${sectionKey}/rewrite`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rewriteDocGenSectionReq,
      signal,
    },
    options,
  );
};

export const getRewriteDocGenSectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewriteDocGenSection>>,
    TError,
    { id: string; sectionKey: string; data?: RewriteDocGenSectionReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewriteDocGenSection>>,
  TError,
  { id: string; sectionKey: string; data?: RewriteDocGenSectionReq },
  TContext
> => {
  const mutationKey = ["rewriteDocGenSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewriteDocGenSection>>,
    { id: string; sectionKey: string; data?: RewriteDocGenSectionReq }
  > = (props) => {
    const { id, sectionKey, data } = props ?? {};

    return rewriteDocGenSection(id, sectionKey, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewriteDocGenSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof rewriteDocGenSection>>
>;
export type RewriteDocGenSectionMutationBody =
  RewriteDocGenSectionReq | undefined;
export type RewriteDocGenSectionMutationError = unknown;

export const useRewriteDocGenSection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rewriteDocGenSection>>,
      TError,
      { id: string; sectionKey: string; data?: RewriteDocGenSectionReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rewriteDocGenSection>>,
  TError,
  { id: string; sectionKey: string; data?: RewriteDocGenSectionReq },
  TContext
> => {
  return useMutation(
    getRewriteDocGenSectionMutationOptions(options),
    queryClient,
  );
};
export const updateDocGenSectionContent = (
  id: string,
  sectionKey: string,
  updateDocGenSectionContentReq?: UpdateDocGenSectionContentReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenSectionResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/sections/${sectionKey}/content`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateDocGenSectionContentReq,
      signal,
    },
    options,
  );
};

export const getUpdateDocGenSectionContentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDocGenSectionContent>>,
    TError,
    { id: string; sectionKey: string; data?: UpdateDocGenSectionContentReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDocGenSectionContent>>,
  TError,
  { id: string; sectionKey: string; data?: UpdateDocGenSectionContentReq },
  TContext
> => {
  const mutationKey = ["updateDocGenSectionContent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDocGenSectionContent>>,
    { id: string; sectionKey: string; data?: UpdateDocGenSectionContentReq }
  > = (props) => {
    const { id, sectionKey, data } = props ?? {};

    return updateDocGenSectionContent(id, sectionKey, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDocGenSectionContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDocGenSectionContent>>
>;
export type UpdateDocGenSectionContentMutationBody =
  UpdateDocGenSectionContentReq | undefined;
export type UpdateDocGenSectionContentMutationError = unknown;

export const useUpdateDocGenSectionContent = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDocGenSectionContent>>,
      TError,
      { id: string; sectionKey: string; data?: UpdateDocGenSectionContentReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDocGenSectionContent>>,
  TError,
  { id: string; sectionKey: string; data?: UpdateDocGenSectionContentReq },
  TContext
> => {
  return useMutation(
    getUpdateDocGenSectionContentMutationOptions(options),
    queryClient,
  );
};
export const upgradeDocGenTaskToFull = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/upgrade-to-full`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getUpgradeDocGenTaskToFullMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradeDocGenTaskToFull>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradeDocGenTaskToFull>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["upgradeDocGenTaskToFull"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradeDocGenTaskToFull>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return upgradeDocGenTaskToFull(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradeDocGenTaskToFullMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradeDocGenTaskToFull>>
>;

export type UpgradeDocGenTaskToFullMutationError = unknown;

export const useUpgradeDocGenTaskToFull = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upgradeDocGenTaskToFull>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upgradeDocGenTaskToFull>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getUpgradeDocGenTaskToFullMutationOptions(options),
    queryClient,
  );
};
export const cancelDocGenTask = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    { url: `/intl/doc-generation/tasks/${id}/cancel`, method: "POST", signal },
    options,
  );
};

export const getCancelDocGenTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelDocGenTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelDocGenTask>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelDocGenTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelDocGenTask>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelDocGenTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelDocGenTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelDocGenTask>>
>;

export type CancelDocGenTaskMutationError = unknown;

export const useCancelDocGenTask = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelDocGenTask>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelDocGenTask>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelDocGenTaskMutationOptions(options), queryClient);
};
export const pinDocGenTask = (
  id: string,
  pinDocGenTaskBody?: PinDocGenTaskBody,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskListItemResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/pin`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: pinDocGenTaskBody,
      signal,
    },
    options,
  );
};

export const getPinDocGenTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pinDocGenTask>>,
    TError,
    { id: string; data?: PinDocGenTaskBody },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pinDocGenTask>>,
  TError,
  { id: string; data?: PinDocGenTaskBody },
  TContext
> => {
  const mutationKey = ["pinDocGenTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pinDocGenTask>>,
    { id: string; data?: PinDocGenTaskBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return pinDocGenTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PinDocGenTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof pinDocGenTask>>
>;
export type PinDocGenTaskMutationBody = PinDocGenTaskBody | undefined;
export type PinDocGenTaskMutationError = unknown;

export const usePinDocGenTask = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pinDocGenTask>>,
      TError,
      { id: string; data?: PinDocGenTaskBody },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof pinDocGenTask>>,
  TError,
  { id: string; data?: PinDocGenTaskBody },
  TContext
> => {
  return useMutation(getPinDocGenTaskMutationOptions(options), queryClient);
};
export const retryDocGenTask = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    { url: `/intl/doc-generation/tasks/${id}/retry`, method: "POST", signal },
    options,
  );
};

export const getRetryDocGenTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryDocGenTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryDocGenTask>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["retryDocGenTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryDocGenTask>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return retryDocGenTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryDocGenTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryDocGenTask>>
>;

export type RetryDocGenTaskMutationError = unknown;

export const useRetryDocGenTask = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof retryDocGenTask>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof retryDocGenTask>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRetryDocGenTaskMutationOptions(options), queryClient);
};
export const regeneratePptDocGenSection = (
  id: string,
  sectionKey: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskDetailResp>(
    {
      url: `/intl/doc-generation/tasks/${id}/sections/${sectionKey}/regenerate`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getRegeneratePptDocGenSectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regeneratePptDocGenSection>>,
    TError,
    { id: string; sectionKey: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regeneratePptDocGenSection>>,
  TError,
  { id: string; sectionKey: string },
  TContext
> => {
  const mutationKey = ["regeneratePptDocGenSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regeneratePptDocGenSection>>,
    { id: string; sectionKey: string }
  > = (props) => {
    const { id, sectionKey } = props ?? {};

    return regeneratePptDocGenSection(id, sectionKey, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegeneratePptDocGenSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof regeneratePptDocGenSection>>
>;

export type RegeneratePptDocGenSectionMutationError = unknown;

export const useRegeneratePptDocGenSection = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regeneratePptDocGenSection>>,
      TError,
      { id: string; sectionKey: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof regeneratePptDocGenSection>>,
  TError,
  { id: string; sectionKey: string },
  TContext
> => {
  return useMutation(
    getRegeneratePptDocGenSectionMutationOptions(options),
    queryClient,
  );
};
export const listDocGenTaskLogs = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DocGenTaskLogResp[]>(
    { url: `/intl/doc-generation/tasks/${id}/logs`, method: "GET", signal },
    options,
  );
};

export const getListDocGenTaskLogsQueryKey = (id: string) => {
  return [`/intl/doc-generation/tasks/${id}/logs`] as const;
};

export const getListDocGenTaskLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocGenTaskLogs>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTaskLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDocGenTaskLogsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDocGenTaskLogs>>
  > = ({ signal }) => listDocGenTaskLogs(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDocGenTaskLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDocGenTaskLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocGenTaskLogs>>
>;
export type ListDocGenTaskLogsQueryError = unknown;

export function useListDocGenTaskLogs<
  TData = Awaited<ReturnType<typeof listDocGenTaskLogs>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTaskLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocGenTaskLogs>>,
          TError,
          Awaited<ReturnType<typeof listDocGenTaskLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDocGenTaskLogs<
  TData = Awaited<ReturnType<typeof listDocGenTaskLogs>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTaskLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocGenTaskLogs>>,
          TError,
          Awaited<ReturnType<typeof listDocGenTaskLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDocGenTaskLogs<
  TData = Awaited<ReturnType<typeof listDocGenTaskLogs>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTaskLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListDocGenTaskLogs<
  TData = Awaited<ReturnType<typeof listDocGenTaskLogs>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDocGenTaskLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListDocGenTaskLogsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
